module.exports = __webpack_public_path__ + "static/media/ungroup.443483d6.svg";